import { render, staticRenderFns } from "./CardEditProfile.vue?vue&type=template&id=53679ba7&"
import script from "./CardEditProfile.vue?vue&type=script&lang=js&"
export * from "./CardEditProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports